import React from "react";
import { PageMeta } from "../../../types/types";
import { Pagination, PaginationContent, PaginationEllipsis, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious } from "../../../ui/Pagination/Pagination";

type Props = {
  page: number;
  setPage: Function;
  meta: PageMeta | undefined;
};

const LogsPagination = ({ page, setPage, meta }: Props) => {
  return (
    <Pagination>
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious
            onClick={() => {
              if (page > 1) setPage(page - 1);
            }}
          />
        </PaginationItem>
        <PaginationItem>
          <PaginationLink isActive={page == 1} onClick={() => setPage(1)}>
            1
          </PaginationLink>
        </PaginationItem>
        {page > 4 && (
          <PaginationItem>
            <PaginationEllipsis />
          </PaginationItem>
        )}
        {meta?.prev_page! - 1 > 1 && (
          <PaginationItem>
            <PaginationLink onClick={() => setPage(meta?.prev_page! - 1)}>{meta?.prev_page! - 1}</PaginationLink>
          </PaginationItem>
        )}
        {meta?.prev_page && meta?.prev_page > 1 && (
          <PaginationItem>
            <PaginationLink onClick={() => setPage(meta.prev_page)}>{meta.prev_page}</PaginationLink>
          </PaginationItem>
        )}
        {page != 1 && page != meta?.total_pages && (
          <PaginationItem>
            <PaginationLink isActive={true}>{page}</PaginationLink>
          </PaginationItem>
        )}
        {meta?.next_page && meta?.next_page < meta?.total_pages && (
          <PaginationItem>
            <PaginationLink onClick={() => setPage(meta.next_page)}>{meta.next_page}</PaginationLink>
          </PaginationItem>
        )}
        {meta?.next_page && meta?.next_page! + 1 < meta?.total_pages! && (
          <PaginationItem>
            <PaginationLink onClick={() => setPage(meta?.next_page! + 1)}>{meta?.next_page! + 1}</PaginationLink>
          </PaginationItem>
        )}
        {meta?.total_pages! - page > 3 && (
          <PaginationItem>
            <PaginationEllipsis />
          </PaginationItem>
        )}
        <PaginationItem>
          <PaginationLink isActive={page == meta?.total_pages} onClick={() => setPage(meta?.total_pages!)}>
            {meta?.total_pages}
          </PaginationLink>
        </PaginationItem>
        <PaginationItem>
          <PaginationNext
            onClick={() => {
              if (page < meta?.total_pages!) setPage(page + 1);
            }}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
};

export default LogsPagination;
